const baseUrl = "https://trx-carabiner.herokuapp.com/api/v1/inspire360proxy"
const limit = 250
const postalCode = document.getElementById('zip')?.value || ''
const now = new Date();
const startsAfter = now.toISOString()

function getMatchingProduct(workshopExternalId) {
  return products.find(product => product.variants[0].sku.toLowerCase() === workshopExternalId.toLowerCase())
}

function sortCoursesByDate(courses) {
  const list = Object.fromEntries(
    Object.entries(courses).sort(([,a],[,b]) => new Date(a.startTime) - new Date(b.startTime))
  );

  return list
}

function reduceCourses(courses) {
  const searchSkus = productSKUs.map(sku => sku.toLowerCase())
  return Object.fromEntries(
    Object.entries(courses).filter(([key, course]) => {
      return searchSkus.includes(course.workshopExternalId.toLowerCase())
    })
  )
}

function parseCourseDate(dates, timezone, isShort) {
  const dateLong = new Intl.DateTimeFormat('en-GB', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })

  const dateShort = new Intl.DateTimeFormat('en-GB', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  })

  const makeTime = new Intl.DateTimeFormat('en-GB', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  })

  const makeZone = new Intl.DateTimeFormat('en-GB', {
    timeZone: timezone,
    timeZoneName: 'short'
  })

  const makeDate = isShort ? dateShort : dateLong

  const day = makeDate.format(new Date(dates.start))
  const startTime = makeTime.format(new Date(dates.start))
  const endTime = makeTime.format(new Date(dates.end))
  const timeZoneDate = makeZone.formatToParts(new Date(dates.end))
  const zone = timeZoneDate.find(part => part.type === "timeZoneName");
  const time = `${startTime} - ${endTime} ${zone.value}`
  return { day, time }
}

async function getProducts(path, singleProduct) {
  let response = await fetch(path)
  if (!response.ok) {
    const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }
  response = await response.json()
  response = await singleProduct ? response.product : response.products
  if (typeof loadingProducts !== 'undefined') loadingProducts = false
  return response
}

async function fetchCourses() {
  const inspire_path = `/api.v3/workshops/instances?status=Active%26startsAfter=${startsAfter}%26location=${postalCode}%26limit=${limit}`
  let response = await fetch(`${baseUrl}?inspire_path=${inspire_path}`)
  if (!response.ok) {
    const message = `An error has occurred fetching courses: ${response.status}`;
    throw new Error(message);
  }
  response = await response.json()
  response = await response.items
  response = sortCoursesByDate(response)
  response = reduceCourses(response)
  return response
}

async function fetchCourse(externalId) {
  const inspire_path = `/api.v3/workshops/instances/?externalId=${externalId}`
  let response = await fetch(`${baseUrl}?inspire_path=${inspire_path}`)
  if (!response.ok) {
    const message = `An error has occurred fetching course: ${response.status}`;
    throw new Error(message);
  }
  response = await response.json()
  response = await response.items
  return response
}
